<template>
    <div v-if="user">
        <div class="flex gap-5">
            <router-link
                active-class=""
                class="rounded px-10 py-5 border-1 border-indigo-200"
                exact-active-class="text-white bg-indigo-400"
                to="/account"
            >Data
            </router-link>
            <router-link
                active-class="text-white bg-indigo-400"
                class="rounded px-10 py-5 border-1 border-indigo-200"
                to="/account/cafes"
            >Cafes
            </router-link>
            <!--            <router-link to="/account/cafes/add">Cafes</router-link>-->
        </div>

        <div class="mt-20">
            <router-view/>
        </div>
    </div>
</template>

<script>
import {mapState} from "vuex";

export default {
    name: "Account",
    data() {
        return {}
    },
    computed: {
        ...mapState([
            'user'
        ])
    },
    watch: {
        user(user) {
            this.redirectIfUserIsLoggedOut(user);
        }
    },
    methods: {
        redirectIfUserIsLoggedOut(user) {
            if (user === null) {
                this.$router.replace({
                    path: '/login',
                    query: {redirectTo: encodeURIComponent(this.$route.fullPath)}
                });
            }
        }
    },
    created() {
        this.redirectIfUserIsLoggedOut(this.user);
    }
}
</script>
